module.exports = __webpack_public_path__ + "static/media/kybpending.9965745b.svg";